<template>
  <div>
    <h5 class="subtitulo">Projetos</h5>
    <div class="row mt-4">
      <div class="col">
        <fcc-select v-model="filtroSituacao" :options="situacoesProjeto" :clearable="false"
          >Situação</fcc-select
        >
      </div>
      <div class="col">
        <fccDateInput type="datetime" required v-model="dtInicio"
          >Data de Início Mínima</fccDateInput
        >
      </div>
      <div class="col">
        <fccDateInput type="datetime" required v-model="dtFim">Data de Entrega Máxima</fccDateInput>
      </div>
      <div class="col-auto">
        <fcc-button @click="limparFiltros" color="outline-secondary">Limpar</fcc-button>
      </div>
      <div class="col">
        <fcc-button @click="filtrarProjetos">Filtrar</fcc-button>
      </div>
    </div>
    <div class="chart-container">
      <div id="chart-projetos-andamento" class="chart"></div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

export default {
  data() {
    return {
      filtroSituacao: null,
      projetosFiltrados: [],
      dtInicio: '',
      dtFim: ''
    }
  },
  computed: {
    ...mapState('acompanhamentoDeProjetos', ['allProjetos', 'situacoesProjeto'])
  },
  watch: {
    allProjetos(value) {
      if (value && value.length > 0) {
        this.filtrarProjetos()
      }
    }
  },
  methods: {
    limparFiltros() {
      this.filtroSituacao = null
      this.dtInicio = ''
      this.dtFim = ''
      this.filtrarProjetos()
    },
    converterParaISO(dataStr) {
      const [data, hora] = dataStr.split(' ')
      const [dia, mes, ano] = data.split('/')
      const [h, m, s] = hora.split(':')

      const date = new Date(Date.UTC(ano, mes - 1, dia, h, m, s))
      return date.toISOString()
    },
    filtrarProjetos() {
      const filtrarPorSituacao = (projeto) =>
        this.filtroSituacao
          ? projeto.tpsituacaoprojeto === this.filtroSituacao.tpsituacaoprojeto
          : projeto

      const filtrarDataInicio = (projeto) => {
        return this.dtInicio
          ? new Date(this.converterParaISO(projeto.dtinicio)) >= new Date(this.dtInicio)
          : projeto
      }

      const filtrarDataFim = (projeto) => {
        return this.dtFim
          ? new Date(this.converterParaISO(projeto.dtentrega)) <= new Date(this.dtFim)
          : projeto
      }

      this.projetosFiltrados = this.allProjetos
        .filter(filtrarPorSituacao)
        .filter(filtrarDataInicio)
        .filter(filtrarDataFim)

      this.renderGraphic()
    },
    formatarData(dataStr) {
      const [data] = dataStr.split(' ')
      const [dia, mes, ano] = data.split('/')

      return `${dia}/${mes}/${ano}`
    },
    renderGraphic() {
      am4core.useTheme(am4themes_animated)

      var chart = am4core.create('chart-projetos-andamento', am4charts.XYChart)
      chart.hiddenState.properties.opacity = 0

      let cellSize = 30
      chart.events.on('datavalidated', function (ev) {
        let chart = ev.target
        const pxPorDia = 12
        const datasInicio = chart.data.map((d) => new Date(d.dtinicio))
        const datasFim = chart.data.map((d) => new Date(d.dtentrega))
        const menorData = new Date(Math.min.apply(null, datasInicio))
        const maiorData = new Date(Math.max.apply(null, datasFim))
        const totalDias = Math.ceil((maiorData - menorData) / (1000 * 60 * 60 * 24)) + 1
        const larguraMinima = chart.svgContainer.htmlElement.parentElement.offsetWidth
        const larguraCalculada = totalDias * pxPorDia
        const larguraFinal = Math.max(larguraCalculada, larguraMinima)
        chart.svgContainer.htmlElement.style.width = larguraFinal + 'px'
        if (larguraCalculada > larguraMinima) {
          chart.scrollbarX = new am4core.Scrollbar()
        }

        let categoryAxis = chart.yAxes.getIndex(0)
        let adjustHeight = chart.data.length * cellSize - categoryAxis.pixelHeight
        let targetHeight = chart.pixelHeight + adjustHeight
        chart.svgContainer.htmlElement.style.height = targetHeight * 1.5 + 'px'
      })

      chart.leftAxesContainer.minWidth = 150
      chart.dateFormatter.inputDateFormat = 'dd/MM/yyyy'

      var colorSet = new am4core.ColorSet()
      colorSet.saturation = 0.4

      chart.data = this.projetosFiltrados.map((item, index) => {
        const color =
          index === 0
            ? colorSet.getIndex(1)
            : colorSet.getIndex(
                index % 2 === 0
                  ? (index + 1) % colorSet.list.length
                  : colorSet.list.length - ((index + 1) % colorSet.list.length)
              )

        return {
          ...item,
          dtinicio: this.formatarData(item.dtinicio),
          dtentrega: this.formatarData(item.dtentrega),
          color
        }
      })

      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = 'descricao'
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.inversed = true

      var dateAxis = chart.xAxes.push(new am4charts.DateAxis())
      dateAxis.dateFormatter.dateFormat = 'dd/MM/yyyy'
      dateAxis.renderer.minGridDistance = 80
      dateAxis.baseInterval = { count: 30, timeUnit: 'day' }

      var series = chart.series.push(new am4charts.ColumnSeries())
      series.columns.template.height = am4core.percent(80)
      series.columns.template.tooltipText = '{descricao}: {openDateX} - {dateX}'

      series.dataFields.openDateX = 'dtinicio'
      series.dataFields.dateX = 'dtentrega'
      series.dataFields.categoryY = 'descricao'
      series.columns.template.propertyFields.fill = 'color'
      series.columns.template.propertyFields.stroke = 'color'
      series.columns.template.strokeOpacity = 1

      chart.scrollbarX = new am4core.Scrollbar()
    }
  }
}
</script>